import React from 'react'
import { ODFileRow } from './ODFileRow'
export function ODFileWithFileName(props) {
  var value = props.value,
    keyPath = props.keyPath,
    onRemove = props.onRemove
  return React.createElement(ODFileRow, {
    value: value,
    keyPath: keyPath,
    render: function (fieldValue, isLocalFile) {
      if (fieldValue === null) {
        return React.createElement('div', null, '\uD30C\uC77C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.')
      }
      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          null,
          isLocalFile && fieldValue.name,
          !isLocalFile &&
            React.createElement(
              'a',
              { href: fieldValue.link, target: '_blank', rel: 'noreferrer noopener' },
              fieldValue.fileName
            ),
          '\u00A0',
          onRemove && React.createElement('span', { style: { cursor: 'pointer' }, onClick: onRemove }, '[\uC0AD\uC81C]')
        )
      )
    },
  })
}
//# sourceMappingURL=ODFileWithFileName.js.map
